import { render, staticRenderFns } from "./MissingScopesAlert.vue?vue&type=template&id=4c918f72"
import script from "./MissingScopesAlert.vue?vue&type=script&lang=js"
export * from "./MissingScopesAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports